module.exports = __webpack_public_path__ + "img/900632753.2a29817f.png";